module.exports = __webpack_public_path__ + "img/DE00704.76bbdfbe.png";